export enum LoginType {
    standard = 'standard',
    sso = 'sso',
}
